<footer class="section-gap footer-section">
  <div class="container">
      <div class="footerNavSection">
          <!-- All Footer B2C and B2B Flights and Hotels Include Role Module -->
          <!-- Data coming from Data Service file in service -->
          <div class="footerWrapper">
              <h3>About Us</h3>
              <ul>
                  <li *ngFor="let item of aboutItem">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
          <div class="footerWrapper">
              <h3>Travel Help</h3>
              <ul>
                  <li *ngFor="let item of travelItem">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
          <div class="footerWrapper">
              <h3>{{travelInfoName}} Information</h3>
              <ul>
                  <li *ngFor="let item of footerInformatin">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
          <div class="footerWrapper">
              <h3>Quick Links</h3>
              <ul>
                  <li *ngFor="let item of quickItem">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
          <div class="footerWrapper">
              <h3>Get in Touch</h3>
              <ul>
                  <li *ngFor="let item of touchItem">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
      </div>
      <!-- <div class="socialMediaSection">
        <a *ngFor="let item of socialMedia" [href]="item.path" target="_blank"><i class="{{item.icon}}"></i></a>
      </div> -->
      <div class="iconITAPayment">
        <div class="wrapperIcon socialMediaSection">
          <a *ngFor="let item of socialMedia" [href]="item.path" target="_blank"><i class="{{item.icon}}"></i></a>
        </div>
          <!-- <div class="wrapperIcon">
              <ul>
                  <li *ngFor="let item of itaIcon">
                      <img [src]="item.path" alt="{{item.name}}" class="img-fluid">
                  </li>
              </ul>
          </div> -->
          <div class="wrapperIcon paymentIcon">
              <ul>
                  <li *ngFor="let item of paymentIcon">
                      <img [src]="item.path" [alt]="item.name" class="img-fluid">
                  </li>
              </ul>
          </div>
      </div>
      <div class="footerPrivacy">
          <div class="privacyPolicy">
              <ul>
                  <li *ngFor="let item of privacyPolicy">
                      <a [href]="isLoggedIn ? 'u/' + item.path : item.path">{{item.label}}</a>
                  </li>
              </ul>
          </div>
          <div class="footerLogo">
              <img [src]="footerImage" alt="Belairtrip.com" class="img-fluid">
          </div>
      </div>
      <div class="footerBottom">
          <p>Copyright &#169; {{today | date: 'yyyy'}} <span>Belair Ticket Centre</span>.<br>All Rights Reserved.</p>
      </div>
  </div>
</footer>
